import React, {CSSProperties, MutableRefObject} from 'react';
import type {UniqueIdentifier} from '@dnd-kit/core';
import {AnimateLayoutChanges, useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import {TreeItemCard, Props as TreeItemProps} from './TreeItemCard.tsx';
import {iOS} from './Tree/utilities.ts';

interface Props extends TreeItemProps {
  id: UniqueIdentifier;
  insertNewItemAfter(ctrlCreate: boolean): void;  
  inputRef: MutableRefObject<null> | null;
}

const animateLayoutChanges: AnimateLayoutChanges = ({isSorting, wasDragging}) =>
  isSorting || wasDragging ? false : true;

export function SortableTreeItemCard({id, done, depth, goal,  insertNewItemAfter, handleOnSubmit, inputRef, ...props}: Props) {
  const {
    attributes,
    isDragging,
    isSorting,
    listeners,
    setDraggableNodeRef,
    setDroppableNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
    animateLayoutChanges,
  });
  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  function sortableTreeItemHandleOnfocus(ctrlCreate: boolean) {
    if(insertNewItemAfter){
      insertNewItemAfter(ctrlCreate);
    }
    
  }

  return (
    <TreeItemCard
      ref={setDraggableNodeRef}
      wrapperRef={setDroppableNodeRef}
      inputRef={inputRef}
      style={style}
      done={done}
      depth={depth}
      ghost={isDragging}
      goal={goal}
      disableSelection={iOS}
      disableInteraction={isSorting}
      treeItemHandleOnfocus={sortableTreeItemHandleOnfocus}
      handleOnSubmit={handleOnSubmit}
      handleProps={{
        ...attributes,
        ...listeners,
      }}
      {...props}
    />
  );
}
